import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { createVNode, reactive } from 'vue';
import { send_product_order, remove_product_order } from '@/api/jms-model';
import { message, notification } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import ls from '@/utils/local-storage';
import { Modal } from 'ant-design-vue/es';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '发货',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '发货信息',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [2, 2],
          },
          fields: [
            {
              type: 'input',
              name: 'sum_num',
              label: '产品总数',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'no_num',
              label: '产品余数',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'num',
              label: '发货产品数量',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写发货产品数量',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '创建日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: false,
              valueFormat: 'YYYY-MM-DD',
              placeholder: '请填写创建日期',
            },
          ],
          rules: {
            num: [{ required: true, message: '请输入发货产品数量' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            num: null,
            no_num: data.no_num,
            sum_num: data.num,
            date: null,
            order_id: Number(data.id),
          }),
        },
        options: {},
        ok: (payload: any) => {
          if (Number(payload.no_num) < Number(payload.num)) {
            notification.error({
              message: '输入数值错误',
              description: '发货数量 > 产品余量',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            send_product_order(payload)
              .then(() => {
                message.success('发货成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '撤单',
    clazz: 'danger',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '撤单仅用于客户退项目，若由于门店操作错误而需撤回订单，请点击作废。',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve1 => {
            const editModal = reactive({
              visible: true,
              loading: false,
              title: '撤单',
              form: {
                settings: {
                  labelAlign: 'right',
                  layout: 'horizontal',
                  col: [2, 3],
                },
                fields: [
                  {
                    type: 'input',
                    name: 'sum_num',
                    label: '产品总数',
                    disabled: true,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'no_num',
                    label: '产品余数',
                    disabled: true,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                  },
                  {
                    type: 'input',
                    name: 'num',
                    label: '撤单产品数量',
                    disabled: false,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                    placeholder: '请填写撤单产品数量',
                  },
                  {
                    type: 'datepicker',
                    name: 'date',
                    label: '创建日期',
                    disabled: false,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                    showTime: false,
                    valueFormat: 'YYYY-MM-DD',
                    placeholder: '请填写创建日期',
                  },
                  {
                    type: 'textarea',
                    name: 'mark',
                    label: '备注',
                    disabled: false,
                    allowClear: true,
                    inputType: 'text',
                    maxlength: 300,
                    defaultValue: '',
                    placeholder: '请填写备注',
                  },
                ],
                rules: {
                  num: [{ required: true, message: '请输入撤单产品数量' }],
                },
                model: reactive({
                  org_id: current_org?.id,
                  is_active: true,
                  num: null,
                  date: null,
                  no_num: data.no_num,
                  sum_num: data.num,
                  mark: null,
                  order_id: Number(data.id),
                }),
              },
              options: {},
              ok: (payload: any) => {
                if (Number(payload.no_num) < Number(payload.num)) {
                  notification.error({
                    message: '输入数值错误',
                    description: '撤单数量 > 产品余量',
                  });
                  return false;
                }
                return new Promise(resolve => {
                  editModal.loading = true;
                  remove_product_order(payload)
                    .then(() => {
                      message.success('撤单成功');
                      event_obj.emit('refresh');
                      resolve(null);
                      resolve1(null);
                    })
                    .finally(() => {
                      editModal.loading = false;
                    });
                });
              },
            });
            modalBox(editModal);
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
